function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -1)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.574,1H1.172A1.107,1.107,0,0,0,0,2.172v1.64L9.373,9.084l9.373-5.155V2.172A1.107,1.107,0,0,0,17.574,1Z",
  transform: "translate(0 -1)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.787,10.621,0,5.7v9.724A1.107,1.107,0,0,0,1.172,16.6h16.4a1.107,1.107,0,0,0,1.172-1.172V5.7L9.958,10.621A1.456,1.456,0,0,1,8.787,10.621Z",
  transform: "translate(0 -0.194)",
  fill: "#fff"
})));

var SvgAlert3 = function SvgAlert3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.745,
    height: 16.402,
    viewBox: "0 0 18.745 16.402",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlert3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert-3.22b47139.svg";
export { ForwardRef as ReactComponent };